/**
 * Generates a fake file on the client-side and triggers the browser's save dialog to download it.
 */
export default function triggerFileDownload(contents: string, filename: string): void {
  const encodedUri = encodeURI(contents)
  const link = document.createElement('a')
  link.setAttribute('href', encodedUri)
  link.setAttribute('download', filename)
  document.body.appendChild(link)

  link.click()
  document.body.removeChild(link)
}
